import { Component, EventEmitter, Output } from '@angular/core';
import { PendingChanges } from './pending-changes.class';

@Component({
  selector: 'section-touched',
  template: '',
  standalone: false,
})
export class SectionTouched extends PendingChanges {
  @Output() sectionTouched = new EventEmitter<string>();

  /**
   * Handler for any event upon which emitting sectionTouched is needed.
   */
  onSectionTouched(sectionName: string): void {
    this.sectionTouched.emit(sectionName);
  }
}
